// extracted by mini-css-extract-plugin
export var phone = "_20-0";